import React from 'react';
import { saveAs } from 'file-saver';
import { writeAuctionToIcsFile } from './helper';

const Calendar = ({ auctionData }) => {
  const saveIcsFile = () => {
    saveAs(writeAuctionToIcsFile(auctionData), 'event.ics');
  };

  return (
    <div onClick={saveIcsFile} style={{ color: '#960000' }}>
      <a target="_blank" rel="noreferrer">
        Add To Calendar
      </a>
    </div>
  );
};

export default Calendar;
